'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const storedConsent = localStorage.getItem('cookie_consent');
    
    if (!storedConsent) {
      setIsVisible(true);
    } else if (storedConsent === 'granted') {
      // Restore consent if previously granted
      if (window._paq) {
        window._paq.push(['rememberConsentGiven']);
      }
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'granted');
    if (window._paq) {
      window._paq.push(['rememberConsentGiven']);
    }
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'denied');
    if (window._paq) {
      window._paq.push(['forgetConsentGiven']);
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm rounded-xl border border-gray-200 bg-white/90 p-6 shadow-2xl backdrop-blur-sm dark:border-gray-700 dark:bg-gray-900/90 transition-all duration-500 ease-in-out">
      <div className="flex flex-col gap-4">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              🍪 Gestione Cookie
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              Utilizziamo i cookie per analizzare il traffico e migliorare la tua esperienza. 
              Rispettiamo la tua privacy e siamo conformi al GDPR. 
              Leggi la nostra <Link href="/cookie-policy" className="underline hover:text-blue-600 dark:hover:text-blue-400">Cookie Policy</Link> e <Link href="/privacy-policy" className="underline hover:text-blue-600 dark:hover:text-blue-400">Privacy Policy</Link>.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            onClick={handleDecline}
            className="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white transition-colors"
          >
            Rifiuta
          </button>
          <button
            onClick={handleAccept}
            className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors shadow-sm"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    _paq: any[];
  }
}
